/* src/app/fitter/pages/fitter-absence-new/fitter-absence-new.component.scss */
/*# sourceMappingURL=fitter-absence-new.component.css.map */
